export default "__VITE_ASSET__CofkVJdw__"